import React, { useContext } from "react";

// Styling
import "./AddNewClassModals.css";

// global state
import { StateContext } from "../../AppStateContext";

// add class state
import {
  SchemaAddClassStateContext,
  SchemaAddClassStateDispatchContext,
} from "./SchemaAddClassStateContext.js";

const AddNewPropertyModalButtons = ({
  propObj,
  setPropObj,
  setIsAddPropertyModalOpen,
}) => {
  // global state
  const state = useContext(StateContext);

  const schemaState = useContext(SchemaAddClassStateContext);
  const schemaSetState = useContext(SchemaAddClassStateDispatchContext);

  // function to add property to schema state obj
  const addProperty = (e) => {
    e.preventDefault();

    schemaSetState({
      ...schemaState,
      properties: [...schemaState.properties, propObj],
    });

    setPropObj({
      name: "",
      description: "",
      dataType: [""],
      vectorizePropName: false,
      index: false,
    });

    setIsAddPropertyModalOpen(false);
  };

  const cancel = (e) => {
    e.preventDefault();

    setIsAddPropertyModalOpen(false);
  };
  return (
    <>
      <button
        className={
          state.theme === "dark"
            ? "__addPropertyButtonModal __addPropertyButtonModalDark"
            : "__addPropertyButtonModal __addPropertyButtonModalLight"
        }
        onClick={addProperty}
        id="addPropertyModalButton"
      >
        Add Property
      </button>
      <button
        className={
          state.theme === "dark"
            ? "__addPropertyButtonCancelModal __addPropertyButtonModalCancelDark"
            : "__addPropertyButtonCancelModal __addPropertyButtonModalCancelLight"
        }
        onClick={cancel}
      >
        Cancel
      </button>
    </>
  );
};

export default AddNewPropertyModalButtons;
